import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-to-arc', 'IconArrowUpToArc', [
  ['path', { d: 'M12 21v-12', key: 'svg-0' }],
  ['path', { d: 'M8 13l4 -4l4 4', key: 'svg-1' }],
  ['path', { d: 'M21 12a9 9 0 0 0 -18 0', key: 'svg-2' }],
]);
